import { render } from "./company_card.vue?vue&type=template&id=e26629f8"
import script from "./company_card.vue?vue&type=script&lang=js"
export * from "./company_card.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__